<template>
	<v-card>
		<v-card-title>
			<h2>Pracownicy placówki</h2>
		</v-card-title>
		<div :key="user.id" v-for="(user,index) in users">
			<v-card style="padding: 10px">
				&emsp; {{1+index}}.{{user.name}} {{user.surname}}
			</v-card>
		</div>
	</v-card>
</template>

<script>
	import {Agency} from "@/api/generated/Agency";

	export default {
		name: "AgencyUsers",
		props: {
			agencyId: {}
		},

		data () {
			return {
				users: []
			};
		},

		mounted () {
			Agency.getUsers(this, this.agencyId, successResponse => {
        this.users = successResponse;
      }, errorResponse => {
        this.$messagesBus.$emit("error", "Nie udało się załadować listy pracowników", errorResponse);
      });
		}
	};
</script>

<style scoped>

</style>